import React, { useState } from "react";
import "./PhoneLogin.css";
import { Phone, KeyRound, RotateCcw } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../navbar/Navbar";
import Footer from "../../footer/Footer";
import SocialMediaPanel from "../../common/social-media/SocialMediaPanel";

const PhoneLogin = () => {
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [generatedOtp, setGeneratedOtp] = useState("");
    const [showOtpField, setShowOtpField] = useState(false);

    const validatePhone = () => /^[6-9]\d{9}$/.test(phone);

    const generateAndShowOtp = () => {
        const otpValue = Math.floor(100000 + Math.random() * 900000).toString();
        setGeneratedOtp(otpValue);

        // Show OTP in toast instead of sending SMS
        toast.success(`Your OTP is: ${otpValue}`, {
            autoClose: 10000,
            theme: "light"
        });
    };

    const handleGetOtp = () => {
        if (!validatePhone()) {
            toast.error("Enter valid 10-digit mobile number starting with 6–9");
            return;
        }
        generateAndShowOtp();
        setShowOtpField(true);
    };

    const handleResetOtp = () => {
        if (!validatePhone()) {
            toast.error("Enter valid phone number first to reset OTP");
            return;
        }
        generateAndShowOtp();
        setOtp(""); // Clear input field
    };

    const handleVerifyOtp = () => {
        if (otp === generatedOtp) {
            toast.success("OTP Verified Successfully!", { theme: "light" });
        } else {
            toast.error("Invalid OTP. Please try again.", { theme: "light" });
        }
    };

    return (
        <>
            
             
            <div className="phone-login-container">
                <div className="phone-login-card">
                    <h2 className="phone-login-title">Phone Login</h2>

                    <div className="phone-login-input-group">
                        <label className="phone-login-label">
                            <Phone size={18} /> Mobile Number
                        </label>
                        <input
                            type="text"
                            value={phone}
                            placeholder="Enter your mobile number"
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                if (val.length <= 10) setPhone(val);
                            }}
                            className="phone-login-input"
                        />
                    </div>

                    {!showOtpField && (
                        <button
                            className="phone-login-btn"
                            onClick={handleGetOtp}
                            disabled={!validatePhone()}
                        >
                            Get OTP
                        </button>
                    )}

                    {showOtpField && (
                        <>
                            <div className="phone-login-input-group">
                                <label className="phone-login-label">
                                    <KeyRound size={18} /> Enter OTP
                                </label>
                                <input
                                    type="text"
                                    value={otp}
                                    maxLength={6}
                                    placeholder="Enter OTP"
                                    onChange={(e) =>
                                        setOtp(e.target.value.replace(/\D/g, ""))
                                    }
                                    className="phone-login-input"
                                />
                                <button
                                    className="phone-login-reset-btn"
                                    onClick={handleResetOtp}
                                >
                                    <RotateCcw size={12} /> Reset OTP
                                </button>
                            </div>

                            <div className="phone-login-btn-group">
                                <button
                                    className="phone-login-btn"
                                    onClick={handleVerifyOtp}
                                    disabled={otp.length !== 6}
                                >
                                    Verify OTP
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
        </>
    );
};

export default PhoneLogin;
